import { PrescricaoType } from '_metronic/helpers/enums'
import type {
  PrescricaoDtoExame,
  PrescricaoDtoFormula,
  PrescricaoDtoMedicamento,
  PrescricaoDtoOrientacao,
} from '../_model'
import { ItemExame, ItemFormula, ItemMedicamento, ItemOrientacao, ItemPrescricao } from './itens'

/** Uma requisição por categoria: é assim que o backend cria (e divide) os rascunhos. */
export type RequisicoesPrescricao = {
  medicamentos?: PrescricaoDtoMedicamento
  formulas?: PrescricaoDtoFormula
  exames?: PrescricaoDtoExame
  orientacoes?: PrescricaoDtoOrientacao
}

const opcional = (valor: string) => valor.trim() || undefined

const medicamento = (item: ItemMedicamento) => ({
  idMedicamento: item.catalogo.id,
  ...(!item.catalogo.id && {
    medicamento: {
      nome: item.catalogo.nome,
      receituario: item.catalogo.receituario,
      concentracao: item.catalogo.concentracao,
      apresentacao: item.catalogo.apresentacao,
    },
  }),
  posologia: item.posologia.trim(),
  quantidade: item.quantidade.trim(),
  observacoes: opcional(item.observacoes),
  usoContinuo: item.usoContinuo,
})

const formula = (item: ItemFormula) => ({
  idFormula: item.catalogo.id,
  ...(!item.catalogo.id && {
    formula: { nome: item.catalogo.nome, descricao: item.catalogo.composicao },
  }),
  posologia: item.posologia.trim(),
  quantidade: item.quantidade.trim(),
  observacoes: opcional(item.observacoes),
})

const exame = (item: ItemExame) => ({
  idExame: item.catalogo.id,
  ...(!item.catalogo.id && { exame: { nome: item.catalogo.nome } }),
  instrucoes: opcional(item.instrucoes),
  observacoes: opcional(item.observacoes),
})

const orientacao = (item: ItemOrientacao) => ({
  idOrientacao: item.catalogo.id,
  orientacao: { nome: item.catalogo.nome, descricao: item.texto },
  texto: item.texto,
})

/** Monta as requisições de criação dos rascunhos a partir dos itens da tela. */
export const montarRequisicoes = (itens: ItemPrescricao[]): RequisicoesPrescricao => {
  const medicamentos = itens.filter(
    (item): item is ItemMedicamento => item.categoria === PrescricaoType.Medicamento
  )
  const formulas = itens.filter(
    (item): item is ItemFormula => item.categoria === PrescricaoType.Formula
  )
  const exames = itens.filter((item): item is ItemExame => item.categoria === PrescricaoType.Exame)
  const orientacoes = itens.filter(
    (item): item is ItemOrientacao => item.categoria === PrescricaoType.Orientacoes
  )

  return {
    ...(medicamentos.length > 0 && {
      medicamentos: { medicamentos: medicamentos.map(medicamento) },
    }),
    ...(formulas.length > 0 && { formulas: { formulas: formulas.map(formula) } }),
    ...(exames.length > 0 && { exames: { exames: exames.map(exame) } }),
    ...(orientacoes.length > 0 && { orientacoes: { orientacoes: orientacoes.map(orientacao) } }),
  }
}
